<template>
  <div>
    <Templete1 v-model="showTemplete1"  :detail="renderDetail" :popDetail="popDetail" @onGiveUp="giveup"></Templete1>
    <Templete2 v-model="showTemplete2"  :detail="renderDetail" :popDetail="popDetail" @onGiveUp="giveup"></Templete2>
    <Templete3 v-model="showTemplete3"  :detail="renderDetail" :popDetail="popDetail" @onGiveUp="giveup"></Templete3>
    <TemplateGiveUp v-model="showTempleteGiveUp"  :giveUpDetail="giveUpDetail" ></TemplateGiveUp>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Templete1 from './templete-1.vue'
import Templete2 from './templete-2.vue'
import Templete3 from './templete-3.vue'
import TemplateGiveUp from './templete-give-up.vue'

export default {
  props: {
    backType: {
      type: String,
      default: () => 'ALL'
    },
    reqType: {
      type: String,
      default: () => 'LOAN'
    }
  },
  components: {
    Templete1,
    Templete2,
    Templete3,
    TemplateGiveUp
  },
  data () {
    return {
      showTemplete1: false,
      showTemplete2: false,
      showTemplete3: false,
      showTempleteGiveUp: false,
      giveUpDetailshow: 'N',  
      popDetail: {
        titleList: [],
        contentList: [],
        smallContentList: [],
        showCloseBtn: 'Y',
        buttonCorner: {},
        secondaryButton: {},
        mainButton: {},
        styleType: ''
      },
      loanPopType: '',
      version: '',
      giveUpDetail: []
    }
  },
  computed: {
    renderDetail () {
      return {
        title: this.title,
        contentList: this.contentList,
        smallContentList: this.smallContentList,
        showCloseBtn: this.popDetail.showCloseBtn,
        buttonCorner: this.buttonCorner,
        secondaryButton: this.secondaryButton,
        mainButton: this.mainButton,
        loanPopType: this.loanPopType
      }
    },
    mainButton () {
      return this.renderStyle(this.popDetail.mainButton)
    },
    secondaryButton () {
      return this.renderStyle(this.popDetail.secondaryButton)
    },
    buttonCorner () {
      return this.renderStyle(this.popDetail.buttonCorner)
    },
    title () {
      return this.renderHtml(this.popDetail.titleList)
    },
    contentList () {
      return this.renderHtml(this.popDetail.contentList)
    },
    smallContentList () {
      return this.renderHtml(this.popDetail.smallContentList)
    }
  },
  mounted () {
    this.getLoanDetentionType()
    this.questionnaireList()
  },
  methods: {
    renderStyle (item) {
      if (!item) return {}
      return {
        fontSize: window.px2rem(item.fontSize) + 'rem',
        color: item.color,
        fontWeight: item.needBold === 'Y' ? 'bold' : 'normal',
        fontFamily: item.fontFamily,
        backgroundColor: item.backgroundColor
      }
    },
    renderHtml (list) {
      const _html = []
      if (list?.length) {
        list.forEach(item => {
          _html.push(`<div style="font-size: ${window.px2rem(item.fontSize)}rem; color: ${item.color}; font-family:${item.fontFamily}; font-weight: ${item.needBold === 'Y' ? 'bold' : 'normal'}">${item.content}</div>`)
        })
      }

      return _html.join('') 
    },
    giveup () {
      if (this.giveUpDetailshow === 'Y') {
        this.handleShowTempleteGiveUp()
      } else {
        this.backHome()
      }
    },
    handleShowTempleteGiveUp () {
      this.showTempleteGiveUp = true
      this.$sensors.track('PopupDisplay', { msg_name: '提现放弃原因收集', caseid: this.loanPopType, styleType: 'STYLE_ONE', version: this.version })
    },
    init () {
      const { styleType } = this.popDetail

      if (styleType && this.backType === 'ALL') {
        switch (styleType) {
          case 'STYLE_TWO':
            this.showTemplete1 = true
            break
          case 'STYLE_THREE':
            this.showTemplete2 = true
            break
          case 'STYLE_FOUR':
            this.showTemplete3 = true
            break
        }
        this.$sensors.track('PopupDisplay', { msg_name: '提现挽留弹窗', caseid: this.loanPopType, styleType })
      } else if (this.giveUpDetailshow === 'Y' && styleType) {
        this.handleShowTempleteGiveUp()
      } else {
        this.backHome()
      }
    },
    async getLoanDetentionType () {
      const { success, data } = await this.getLoanDetentionPopType({
        reqType: this.reqType
      })
      if (success && data?.popDTO) {
        this.popDetail = data.popDTO
        this.loanPopType = data.loanPopType
      } 
    },
    async questionnaireList () {
      const { success, data } = await this.questionnaireListX({
        questionnaire: 'WITHDRAW_POP'
      })
      if (success && data) {
        this.giveUpDetailshow = data.popUp
        this.giveUpDetail = data.popContent
        this.version = data.version
      } 
    },
    ...mapActions('withdraw', [
      'getLoanDetentionPopType',
      'questionnaireListX'
    ])
    
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";


</style>